import { toPrice } from '@/helpers/toPrice'
import Box from '@components/Box'
import Tooltip from '@components/Tooltip'
import { STypographyDefault, STypographyParagraph } from '@components/Typography'
import { above } from '@styles/mixins/breakpoints'
import React from 'react'
import styled, { css } from 'styled-components'
import { IResult } from '../types'

const SBigNumber = styled(STypographyDefault)`
  color: ${({theme}) => theme.colors.green};
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  width: 100%;
  
  ${above('md')(css`
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
  `)}

  ${above('xl')(css`
    font-size: 32px;
    line-height: 40px;
  `)}
`

const SDesc = styled(STypographyDefault)`
  width: 70%;
  margin-right: 20px;
  flex-shrink: 0;
  flex-grow: 0;
  ${above('xl')(css`
    width: 260px;
  `)}
`

const SWarning = styled.div`
  background: ${({theme}) => theme.colors.green};
  color: ${({theme}) => theme.colors.white};
  padding: 15px 10px;
  border-radius: 8px;
  margin-bottom: 32px;
`

const Result: React.FC<IResult> = ({ warning, contributionSize, contributionSizePercent, employerContributionSize, employerContributionSizePercent }) => {
  const getPercent = (value: number) => `${ value.toLocaleString(undefined, {maximumFractionDigits: 1}) } %`
  const getPrice = (value: number) => `${Math.round(value).toLocaleString()} ₽`

  return (
    <>
      <STypographyParagraph fontWeight="600" mb="8px">
        Расчетная информация по удержанию из заработной платы
      </STypographyParagraph>
      <STypographyDefault color="darkGray" mb="32px">
        Взнос работника не может быть менее 500 ₽
      </STypographyDefault>
      {warning && (
        <SWarning>
          {warning}
        </SWarning>
      )}
      <Box display="flex" mb="16px">
        <SDesc>
          Ежемесячный пенсионный взнос, % от заработной платы
        </SDesc>
        <SBigNumber>
          { getPercent(contributionSizePercent) }
        </SBigNumber>
      </Box>
      <Box display="flex" mb="44px">
        <SDesc>
          Ежемесячный пенсионный взнос
        </SDesc>
        <SBigNumber>
          {getPrice(contributionSize)}
        </SBigNumber>
      </Box>
      <STypographyParagraph fontWeight="600" mb="8px">
        Начисление на КИПС от работодателя
      </STypographyParagraph>
      <STypographyDefault color="darkGray" mb="32px">
        Взнос работодателя не может быть менее 750 ₽ и более 5000 ₽
      </STypographyDefault>
      <Box display="flex" mb="16px">
        <SDesc>
          Ежемесячный пенсионный взнос, % от заработной платы <Box as="span" ml="9px">
            <Tooltip place="top" id="result">
              (максимальный взнос Предприятия - 5,5%
              <br />
              от зарплаты Участника)
            </Tooltip>
          </Box>
        </SDesc>
        <SBigNumber>
          { getPercent(employerContributionSizePercent) }
        </SBigNumber>
      </Box>
      <Box display="flex">
        <SDesc>
          Ежемесячный пенсионный взнос
        </SDesc>
        <SBigNumber>
        { getPrice(employerContributionSize) }
        </SBigNumber>
      </Box>
    </>
  )
}

export default Result